import React from "react";
import { View, Text, StyleSheet, Dimensions, Platform } from "react-native";
import LhButton from "../../components/LhButton";
import FontFamily from "../../constants/fonts";
import { useTheme } from "../../theme";

// Props for ObservationWelcome component
interface ObservationWelcomeProps {
  onEmployeeUpdateClick: () => void;
  openFilterOverlay: () => void;
}

const ObservationWelcome: React.FC<ObservationWelcomeProps> = ({
  openFilterOverlay,
}) => {
  const { colors, resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  // Helper function to check if device is in mobile layout
  const isMobileView = () => {
    const windowWidth = Dimensions.get("window").width;
    return (
      Platform.OS === "ios" || Platform.OS === "android" || windowWidth < 768
    );
  };

  // Helper function to check if device is a very small mobile device
  const isVerySmallMobileView = () => {
    const windowWidth = Dimensions.get("window").width;
    return (
      (Platform.OS === "ios" || Platform.OS === "android") && windowWidth < 375
    );
  };

  // Determine whether to show button text based on screen size
  const showButtonText = !isVerySmallMobileView();

  return (
    <View style={styles.welcomeCard}>
      <View style={styles.welcomeContainer}>
        <View style={styles.welcomeLeftContent}>
         
          <Text style={[styles.welcomeText, { color: isDark ? colors.text.primary : '#212529' }]}>Observation Dashboard</Text>
        </View>
        <View
          style={
            isMobileView() ? styles.beginButtonRowMobile : styles.beginButtonRow
          }
        >
          <LhButton
            testID="beginButton"
            text={showButtonText ? "Begin" : ""}
            variant="primary"
            size="small"
            iconTrailing="arrow-forward"
            iconSize={20}
            onPress={openFilterOverlay}
            isLoading={false}
            disabled={false}
            style={showButtonText ? styles.beginButton : styles.iconOnlyButton}
          />
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  welcomeCard: {
    
    
  },
  welcomeContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    
    padding: 0,
    paddingBottom:16,
    flexWrap: "nowrap", // Always keep in same row
  },
  welcomeLeftContent: {
    flexDirection: "row",
    alignItems: "center",
    flexShrink: 1, // Allow this to shrink if needed
  },
  welcomeText: {
    fontFamily: FontFamily.bold,
    fontWeight: '700',
    fontStyle: 'normal',
    fontSize: 28, 
    lineHeight: 32, 
    letterSpacing: 0,
    color: '#212529',
    flexShrink: 1, 
  },
  beginButtonRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    gap: 10,
    alignItems: "center",
    width: "auto",
    marginTop: 0,
  },
  beginButtonRowMobile: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    width: "auto",
    marginTop: 0,
    gap: 10,
  },
  beginButton: {
    width:
      Dimensions.get("window").width < 400
        ? 90
        : Platform.OS === "web"
        ? "15%"
        : 120,
    minWidth: Platform.OS === "web" ? 120 : 60,
    fontSize: Dimensions.get("window").width < 400 ? 12 : 16,
  },
  iconOnlyButton: {
    width: 50,
    minWidth: 50,
    aspectRatio: 1,
    justifyContent: "center",
    alignItems: "center",
  },
});

export default ObservationWelcome;
